import * as API from "middleware/api";

export const listDeposits = (params) => API.executeWithAccessToken("/deposits.list", params);

export const listDepositsRates = (params) => API.executeWithAccessToken("/deposits.rates.list", params);

export const listHistoricalDeposits = (params) => API.executeWithAccessToken("/deposits.list", params);

export const newDepositSimulation = (params) => API.executeWithAccessToken("/request.deposit.preview", params);

export const listCredentialsGroups = (params) =>
    API.executeWithAccessToken("/core.listTransactionCredentialsGroups", params);

export const depositRequest = (params) => API.executeWithAccessToken("/request.deposit.send", params);

export const signDepositTransaction = (params) => API.executeWithAccessToken("/core.signTransaction", params);

export const newAgreementRequest = (params) => API.executeWithAccessToken("/request.agreement.send", params);

export const cancelAutorenewalRequest = (params) => API.executeWithAccessToken("/deposit.cancelRenewal.send", params);
export const downloadDepositLists = (params) => API.executeWithAccessToken("/deposits.downloadDeposits", params);

export const downloadDeposit = (deposit, fileFormat, active) =>
    API.executeWithAccessToken("/deposits.downloadDetailDeposit", {
        deposit,
        format: fileFormat,
        active,
    });

export const acceptTermDeposit = (idGeneralConditionsTrx, category) =>
    API.executeWithAccessToken("/accept.terms.conditions", { idGeneralConditionsTrx, category });
